import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from './components/auth/authService';

const PrivateRoute = ({ element: Element, isCollapsed, toggleSidebar }) => {
    const currentUser = authService.getCurrentUser();

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    if (!currentUser.is_filled) {
        return <Navigate to="/user-form" />;
    }

    return <Element isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />;
};

export default PrivateRoute;
